<div class="">
  <div class="d-flex align-items-center inputDecor"
  [ngClass]="{
       'has-value': mobileNumber
     }"
  >
  <div class="d-flex flex-column flag-dropdown-wrapper">
    <dl id="country-select" class="flagDropdown" [class.disabled]="disabled">
      <dt>
        <a [attr.country_code]="selectedCountry.dial_code" (click)="toggleDropdown()">
          <span class="d-flex align-items-center gap-1">
            <span class="flag-icon" [ngStyle]="{ 'background-position': selectedCountry.flag_position }"></span>
            <span>{{ selectedCountry.name }}</span>
            <span>{{ selectedCountry.dial_code }}</span>
          </span>
        </a>
      </dt>
      <dd>
        <ul [style.display]="dropdownVisible ? 'block' : 'none'">
          <li *ngFor="let country of countries">
            <a [attr.country_code]="country.dial_code" (click)="selectCountry(country);">
              <span class="flag-icon" [ngStyle]="{ 'background-position': country.flag_position }"></span>
              <span>{{ country.name }}</span>
              <span>{{ country.dial_code }}</span>
            </a>
          </li>
        </ul>
      </dd>
    </dl>
  </div>
  <div class="d-flex flex-column flex-grow-1">
    <input 
    type="text"
    [value]="mobileNumber"
    class="form-control custom-input-style"
    placeholder="Mobile Number" 
    (input)="onMobileInput($event);"
    [disabled]="disabled">
  </div>
  </div>
</div>